import React, { useState, useEffect } from "react";
import { Modal, Button } from "react-bootstrap";
import API from "../../config/axios";
import { api_paths } from "../../config/api.paths";
import { toastSuccessMessage, toastErrorMessage } from "../../utils/utils";
import { useDispatch } from "react-redux";
import { SET_LOADING } from "../../redux/user";

const EmailVerificationModal = ({
    show,
    onHide,
    email,
    onVerified,
}) => {
    const dispatch = useDispatch();
    const [otp, setOtp] = useState("");
    const [otpId, setOtpId] = useState(null);
    const [step, setStep] = useState("send"); // 'send' or 'verify'
    const [error, setError] = useState("");

    useEffect(() => {
        if (show) {
            setStep("send");
            setOtp("");
            setError("");
            setOtpId(null);
        }
    }, [show]);

    const handleSendOtp = async (e) => {
        if (e) e.preventDefault();
        if (!email) {
            setError("Email is required");
            return;
        }

        try {
            dispatch(SET_LOADING(true));
            const response = await API.post(api_paths.auth.GUEST_SEND_OTP, { email });
            if (response.data?.payload?.result?.otp_id) {
                setOtpId(response.data.payload.result.otp_id);
                toastSuccessMessage("OTP sent to your email!");
                setStep("verify");
                setError("");
            }
        } catch (err) {
            console.error(err);
            toastErrorMessage(err?.response?.data?.message || "Failed to send OTP");
        } finally {
            dispatch(SET_LOADING(false));
        }
    };

    const handleVerifyOtp = async (e) => {
        e.preventDefault();
        if (!otp) {
            setError("Please enter OTP");
            return;
        }

        try {
            dispatch(SET_LOADING(true));
            const response = await API.post(api_paths.auth.GUEST_VERIFY_OTP, {
                otp_id: otpId,
                otp,
            });

            if (response.data?.payload?.result?.success) {
                toastSuccessMessage("Email verified successfully!");
                onVerified();
                onHide();
            }
        } catch (err) {
            console.error(err);
            toastErrorMessage(err?.response?.data?.message || "Verification failed");
            setError("Invalid OTP");
        } finally {
            dispatch(SET_LOADING(false));
        }
    };

    return (
        <Modal show={show} onHide={onHide} centered>
            <Modal.Header closeButton>
                <Modal.Title className="w-100 text-center fw-semibold">
                    Verify Email
                </Modal.Title>
            </Modal.Header>

            <Modal.Body className="pt-3 px-4 pb-4">
                {step === "send" ? (
                    <div className="py-2">
                        <p className="text-center mb-4">
                            We need to verify your email address <strong>{email}</strong> before proceeding.
                        </p>
                        <Button
                            className="w-100 btn-orange-lg"
                            onClick={handleSendOtp}
                        >
                            Send Verification Code
                        </Button>
                    </div>
                ) : (
                    <form onSubmit={handleVerifyOtp}>
                        <p className="text-center small mb-3">
                            Enter the 6-digit code sent to <strong>{email}</strong>
                        </p>
                        <div className="mb-3">
                            <input
                                type="text"
                                placeholder="Enter OTP"
                                className="form-control text-center message-box"
                                style={{ fontSize: "24px", letterSpacing: "4px" }}
                                value={otp}
                                onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
                                maxLength={6}
                            />
                            {error && <small className="text-danger d-block mt-2 text-center">{error}</small>}
                        </div>

                        <Button
                            type="submit"
                            className="w-100 btn-orange-lg mb-2"
                            style={{
                                backgroundColor: "#F4A528",
                                border: "none",
                                fontWeight: 600,
                            }}
                        >
                            Verify Code
                        </Button>

                        <div className="text-center mt-3">
                            <span
                                className="text-muted small"
                                style={{ cursor: "pointer", textDecoration: "underline" }}
                                onClick={handleSendOtp}
                            >
                                Resend Code
                            </span>
                        </div>
                    </form>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default EmailVerificationModal;
